// frontend_app/src/lib/storage.js
//
// localStorage wrappers that never throw: storage can be unavailable in
// private windows or when site data is blocked, and the app must still work.

export const readString = (key, fallback = null) => {
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? fallback : value;
  } catch (e) {
    return fallback;
  }
};

export const writeString = (key, value) => {
  try {
    if (value === null || value === undefined) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, String(value));
  } catch (e) {
    /* storage unavailable: preference lasts for this session only */
  }
};

export const readJSON = (key, fallback) => {
  const raw = readString(key);
  if (raw === null) return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

export const writeJSON = (key, value) => {
  writeString(key, value === undefined ? null : JSON.stringify(value));
};
